module.exports = __webpack_public_path__ + "fonts/AlbertSans-VariableFont_wght.777206c.ttf";